/*
 * Gets Google Maps link for a given location
 */
function useMapLink(location) {
  if (!location) return '';

  if (location.latitude && location.longitude) {
    if (location.google_place_id) {
      return `https://www.google.com/maps/search/?api=1&query=${location.latitude},${location.longitude}&query_place_id=${location.google_place_id}`;
    } else {
      return `https://www.google.com/maps/search/?api=1&query=${location.latitude},${location.longitude}`;
    }
  }

  if (location.google_place_id) {
    return `https://www.google.com/maps/place/?q=place_id:${location.google_place_id}`;
  }

  if (location.address) {
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(location.address)}`;
  }

  return '';
}

export default useMapLink;
